export const convertEnumToArray = <T extends String>(input: T[]) =>
  input.map((i) => i.toString());
